import { useRouter } from 'next/router';

export const useURLQuery = () => {
  const router = useRouter();

  const removeParam = (paramToRemove: string) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { [paramToRemove]: paramValue, ...rest } = router.query;
    router.push(
      {
        query: { ...rest },
      },
      undefined,
      { shallow: true },
    );
  };

  const removeAllParams = () => {
    router.push(
      {
        query: {},
      },
      undefined,
      { shallow: true },
    );
  };

  const updateURLParams = (paramKey: string, paramValue: string | string[]) => {
    const queryParams = JSON.parse(`{"${paramKey}":"${paramValue}"}`);
    router.push(
      {
        query: { ...router.query, ...queryParams },
      },
      undefined,
      { shallow: true },
    );
  };

  return {
    removeParam,
    removeAllParams,
    updateURLParams,
  };
};
